import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import '../styles/components/Footer.css';

const Footer = () => {
    const [settings, setSettings] = useState(null);

    useEffect(() => {
        fetchSettings();
    }, []);

    const fetchSettings = async () => {
        try {
            const response = await api.getSettings('flat');
            if (response.success) {
                setSettings(response.data);
            }
        } catch (error) {
            console.error('Error fetching settings:', error);
        }
    };

    return (
        <footer className="footer-section">
            <div className="container">
                <div className="row">
                    {/* Left Column - Navigation Links */}
                    <div className="col-xl-9 col-lg-12 mb-4">
                        <div className="footer-navigation">
                            <div className="footer-nav-row">
                                <div className="footer-nav-group">
                                    <h5 className="footer-nav-title">
                                        <Link to="/about-us">About Us</Link>
                                    </h5>
                                    <ul className="footer-nav-sublinks mt-2">
                                        <li><Link to="/experimentation-academy">Shape</Link></li>
                                        <li><Link to="/experimentation-zone">Test</Link></li>
                                        <li><Link to="/lab-stories">Share</Link></li>
                                    </ul>
                                </div>

                                <div className="footer-nav-group">
                                    <h5 className="footer-nav-title">
                                        <Link to="/tools">Resource Library</Link>
                                    </h5>
                                </div>

                                <div className="footer-nav-group">
                                    <h5 className="footer-nav-title">
                                        <Link to="/supernova-tools">Supernova Tools</Link>
                                    </h5>
                                </div>

                                <div className="footer-nav-group">
                                    <h5 className="footer-nav-title">
                                        <Link to="/get-involved">Get Involved</Link>
                                    </h5>
                                </div>

                                <div className="footer-nav-group">
                                    <h5 className="footer-nav-title">
                                        <Link to="/fellowships">Fellowships</Link>
                                    </h5>
                                </div>

                                <div className="footer-nav-group">
                                    <h5 className="footer-nav-title">
                                        <Link to="/blog">Blog</Link>
                                    </h5>
                                </div>

                                <div className="footer-nav-pair">
                                    <div className="footer-nav-group">
                                        <h5 className="footer-nav-title">
                                            <Link to="/whats-next">What's Next</Link>
                                        </h5>
                                    </div>

                                    <div className="footer-nav-group">
                                        <h5 className="footer-nav-title">
                                            <Link to="/careers">Opportunities</Link>
                                        </h5>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    {/* Right Column - Brand & Description */}
                    <div className="col-xl-3 col-lg-12 mb-4">
                        <div className="footer-brand-section">
                            <Link to="/">
                                <img
                                    src="/assets/images/footerlogo.svg"
                                    alt="Supernova Lab"
                                    className="footer-logo "
                                />
                            </Link>
                            <p className="footer-description">
                                "Building what you need next. A state-backed R&D and experimentation platform transforming how governments design, test and scale innovation."
                            </p>

                            {/* Social Links - Bottom Right */}
                            <div className="footer-social-right mt-4">
                                <a
                                    href={settings?.social_instagram || "#instagram"}
                                    className="social-icon"
                                    aria-label="Instagram"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <i className="fab fa-instagram"></i>
                                </a>
                                <a
                                    href={settings?.social_linkedin || "#linkedin"}
                                    className="social-icon"
                                    aria-label="LinkedIn"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <i className="fab fa-linkedin-in"></i>
                                </a>
                                <a
                                    href={settings?.social_facebook || "#facebook"}
                                    className="social-icon"
                                    aria-label="Facebook"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <i className="fab fa-facebook-f"></i>
                                </a>
                                <a
                                    href={settings?.social_twitter || "#twitter"}
                                    className="social-icon"
                                    aria-label="Twitter"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <i className="fab fa-twitter"></i>
                                </a>
                                <a
                                    href={settings?.social_youtube || "#youtube"}
                                    className="social-icon"
                                    aria-label="YouTube"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <i className="fab fa-youtube"></i>
                                </a>
                                <a
                                    href={settings?.social_tiktok || "#tiktok"}
                                    className="social-icon"
                                    aria-label="TikTok"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <i className="fab fa-tiktok"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <p className="d-flex justify-content-center mt-5">
                        © {new Date().getFullYear()} {settings?.site_name || ""} All rights reserved. - Developed by&nbsp;
                        <span style={{ color: 'var(--nova-blue)' }}>Baroow Digital Agency Inc.</span>
                    </p>
                </div>

            </div>
        </footer>
    );
};

export default Footer;
